import {
  EuiButton,
  EuiButtonEmpty,
  EuiCallOut,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { useDataTableContext } from "../store/DataTableProvider";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";

interface ModalDeleteRowsProps {
  tableId: string;
  rowIds: string[];
  onClose: () => void;
}

export const ModalDeleteRows = ({
  tableId,
  rowIds,
  onClose,
}: ModalDeleteRowsProps) => {
  const deleteRows = useDataTableContext((s) => s.deleteRows);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const { error } = await deleteRows({ tableId, rowIds });
    setIsLoading(false);

    if (error === undefined) {
      addUtilityToastSuccess("Row(s) deleted");
    } else {
      addUtilityToastFailure("Failed to delete row(s)");
    }

    onClose();
  };

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle component="h3">Delete Row(s)</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiCallOut
          title="Proceed with caution!"
          color="warning"
          iconType="warning"
        >
          <p>
            Cells in the deleted rows may be referenced in other tables.
            Deleting these rows might cause unwanted changes to your data.
          </p>
        </EuiCallOut>
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>
        <EuiButton
          isLoading={isLoading}
          fill
          color="danger"
          onClick={() => void handleSubmit()}
        >
          Delete
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
};
